__turbopack_context__.v({
  "caption": "Mermaid-module__cG-5ha__caption",
  "diagram": "Mermaid-module__cG-5ha__diagram",
  "loading": "Mermaid-module__cG-5ha__loading",
  "loadingSpinner": "Mermaid-module__cG-5ha__loadingSpinner",
  "mermaidFigure": "Mermaid-module__cG-5ha__mermaidFigure",
  "spin": "Mermaid-module__cG-5ha__spin",
});
